module.exports = __webpack_public_path__ + "img/enfant.50c84419.png";